import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentDmsInlineEnumValueType on DmsInlineEnumValueType {
    entries {
      id
      name
      description
    }
    isMultiselect
  }
`
export const TRANSFORMER: graphql.transformers.OUT.Transformer<
  graphql.schema.FragmentDmsInlineEnumValueTypeFragment | Nullish,
  ents.core.dms.data.Value.Type.Enum.Inline | undefined
> = graphql.transformers.OUT.nest(
  'inlineEnum',
  graphql.transformers.OUT.instance<
    graphql.schema.FragmentDmsInlineEnumValueTypeFragment,
    typeof ents.core.common.value.types.Enum
  >(
    ents.core.common.value.types.Enum,
    graphql.transformers.OUT.object<
      graphql.schema.FragmentEnumValueTypeFragment,
      ents.core.common.value.types.Enum.constructor.Params
    >({
      entries: graphql.transformers.OUT.default(
        graphql.transformers.OUT.list(
          graphql.transformers.OUT.object({
            description: transformers.PASS_THROUGH,
            id: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNotNullish,
              { warnOnly: true },
            ),
            name: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNotNullish,
              { warnOnly: true },
            ),
          }),
          { onNullish: 'remove' },
        ),
        [],
      ),
      isMultiselect: transformers.PASS_THROUGH,
    }),
  ),
  { onNullish: 'remove' },
)
